import { createGlobalStyle, css } from 'styled-components';

const RewriteStyle = createGlobalStyle`${css`
	:root {
		--core_contPaddingLR: var(--contPaddingLR);
		--core_sectionDistance: var(--sectionDistance);

		/* --projectBtnBorderRadius: var(--sp5x); */
		--projectBtnBorderRadius: var(--sp1x);

		--cartSelectControlBorderRadius: var(--sp4x);
		--cartSelectControlPadTB: var(--sp0-5x);
		--cartSelectControlPadLR: var(--sp2x);
		--cartSelectControlGap: var(--sp0-5x);

		--cartSelectMenuBorderRadius: var(--sp1-5x);
		--cartSelectMenuPadTB: 0;
		--cartSelectMenuPadLR: 0;

		--cartSelectOptionPadTB: calc(var(--sp0-5x) / 2);
		--cartSelectOptionPadLR: var(--cartSelectControlPadLR);

		--cartPopupWrapCenterGap: var(--sp3x);

		--padPopupLR: var(--sp35x);
		--borderRadiusPopup: var(--sp4x);
		--sizeClosePopupT: var(--sp6x);
		--sizeClosePopupR: var(--sp5x);
		--sizeClosePopup: var(--sp4x);

		--forgetLinkWrapMTop: var(--sp3x);
		--forgetAgainWrapMTop: var(--sp3x);

		--paginationHistoryBalanceMargin: var(--sp2x);

		--popupDeliveryPad: var(--sp8x) var(--sp17x) var(--sp5x);

		--popupAddressFieldRow: var(--sp3x);
		--popupAddressFieldColumn: 6px;
	}

	//! Catalog

	.menu-products-mobile-filter {
		.external-wrapper {
			.filter-container {
				.filter-bottom-block {
					z-index: 101 !important;
				}
			}
		}
	}

	//! Global Form Item
	.form-item {
		&.disabled {
			opacity: 1 !important;
		}
	}

	/*// ! Popup Delivery Home */
	.popup-address-form-block {
		.popup-content-container {
			max-width: calc(100vw / 12 * 9) !important;
		}

		.popup-content-wrap {
			padding: var(--sp4x) !important;
		}

		.close-wrap {
			top: min(var(--sizeClosePopupT), var(--sp4x)) !important;
			right: min(var(--sizeClosePopupR), var(--sp4x)) !important;
			--core_closeSize: min(var(--sizeClosePopup), var(--sp3x)) !important;
		}
	}

	.cart-modification-warning-popup,
	.delivery-template-popup {
		.popup-content-container {
			max-width: 920px !important;
		}

		.popup-content-wrap {
			overflow: visible !important;
			padding: var(--popupDeliveryPad) !important;
		}

		.close-wrap {
			top: min(var(--sizeClosePopupT), var(--sp4x)) !important;
			right: min(var(--sizeClosePopupR), var(--sp4x)) !important;
			--core_closeSize: min(var(--sizeClosePopup), var(--sp3x)) !important;
		}
	}

	/* //! Cart modification warning popup */
	.cart-modification-warning-popup {
		.cmwp-cancel,
		.cmwp-confirm {
			a,
			button {
				font-weight: 500;
			}
		}

		.cmwp-title {
			font-size: var(--h6) !important;
		}
	}

	/* //! Sign In Styles */
	.sign-in-wrapper {
		.title {
			font-weight: 400;
		}

		label {
			font-weight: 500;
		}

		.btn-wrap {
			button,
			a {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}

		.joinNowWrap {
			> .comp-text {
				font-weight: 400;
			}

			.joinNowLink {
				font-weight: 500;
			}
		}
	}

	/* //! Forgot Styles */
	.forgot-password-wrapper {
		.title {
			font-weight: 400;
		}

		label {
			font-weight: 500;
		}

		.btn-wrap {
			button,
			a {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}
	}

	/* //! Sign Up Styles */
	.sign-up-wrapper {
		.title {
			font-weight: 400;
		}

		label {
			font-weight: 500;
		}

		.privacy-wrap {
			line-height: 1.5715;

			> .link-item {
				transition: color 0.2s ease-out;

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							color: var(--pink1000);
						}
					}
				}
			}
		}

		.btn-wrap {
			button,
			a {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}

		.already-wrap {
			> .comp-text {
				font-weight: 400;
			}

			.login-wrap {
				> .link-item {
					.joinNowLink {
						transition: color 0.2s ease-out;

						@media (pointer: fine) {
							@media (hover: hover) {
								&:hover {
									color: var(--pink1000);
								}
							}
						}
					}
				}
			}
		}
	}

	/* //! Reset Password Styles */
	.reset-password-wrapper {
		.title {
			font-weight: 400;
		}

		label {
			font-weight: 500;
		}

		.btn-wrap {
			button,
			a {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}
	}

	/* //! Verify Code Styles */
	.verify-code-wrapper {
		.title {
			font-weight: 400;
		}

		.verify-contact-wrap,
		.verify-hint {
			font-weight: 400 !important;
		}

		.btn-wrap {
			button,
			a {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}

		.receive-your-code-wrap {
			font-weight: 400;
		}

		.resend-wrap {
			font-weight: 500;
		}
	}

	/* //! Account Styles */
	.account-wrap {
		.sidebar-inner-wrap {
			will-change: transform;
		}

		.my-acc-wrap {
			> .comp-text {
				font-weight: 500;
			}
		}

		.tabs-wrap {
			.menu-item {
				.sidebar-item {
					color: var(--neutral300) !important;
					font-weight: 400;
				}

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							.sidebar-item {
								color: var(--pink1000) !important;
							}
						}
					}
				}

				&.active {
					.sidebar-item {
						color: var(--neutral1000) !important;
						font-weight: 500;
					}
				}
			}
		}

		.sign-out {
			color: var(--pink1000);
			font-weight: 500;
			transition: color 0.2s ease-out;

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						color: var(--neutral300);
					}
				}
			}
		}

		.account-info {
			> .comp-text {
				font-weight: 500;
			}

			> .btn-wrap {
				a,
				button {
					font-weight: 500;
					color: rgba(0, 0, 0, 0.4);

					@media (pointer: fine) {
						@media (hover: hover) {
							&:hover {
								color: var(--pink1000);
							}
						}
					}
				}
			}

			label {
				font-weight: 500;
			}

			form {
				.cancel-and-save-and-apply-wrap {
					.btn-wrap:first-child {
						a,
						button {
							font-weight: 500;
							color: rgba(0, 0, 0, 0.4);

							@media (pointer: fine) {
								@media (hover: hover) {
									&:hover {
										color: var(--pink1000);
									}
								}
							}
						}
					}

					.btn-wrap:last-child {
						button,
						a {
							font-weight: 500;
							border-radius: var(--projectBtnBorderRadius);
						}
					}
				}
			}
		}

		.account-password {
			> .comp-text {
				font-weight: 500;
			}

			> .btn-wrap {
				a,
				button {
					font-weight: 500;
					color: rgba(0, 0, 0, 0.4);

					@media (pointer: fine) {
						@media (hover: hover) {
							&:hover {
								color: var(--pink1000);
							}
						}
					}
				}
			}

			label {
				font-weight: 500;
			}

			form {
				.cancel-and-save-and-apply-wrap {
					.btn-wrap:first-child {
						a,
						button {
							font-weight: 500;
							color: rgba(0, 0, 0, 0.4);

							@media (pointer: fine) {
								@media (hover: hover) {
									&:hover {
										color: var(--pink1000);
									}
								}
							}
						}
					}

					.btn-wrap:last-child {
						button,
						a {
							font-weight: 500;
							border-radius: var(--projectBtnBorderRadius);
						}
					}
				}
			}
		}

		.account-subscription {
			> .comp-text {
				font-weight: 500;
			}

			> .btn-wrap {
				a,
				button {
					font-weight: 500;
					color: rgba(0, 0, 0, 0.4);

					@media (pointer: fine) {
						@media (hover: hover) {
							&:hover {
								color: var(--pink1000);
							}
						}
					}
				}
			}

			label {
				font-weight: 500;
			}

			.cancel-and-save-and-apply-wrap {
				.btn-wrap:first-child {
					a,
					button {
						font-weight: 500;
						color: rgba(0, 0, 0, 0.4);

						@media (pointer: fine) {
							@media (hover: hover) {
								&:hover {
									color: var(--pink1000);
								}
							}
						}
					}
				}

				.btn-wrap:last-child {
					button,
					a {
						font-weight: 500;
						border-radius: var(--projectBtnBorderRadius);
					}
				}
			}
		}
	}

	/* //! Order History Styles */
	.order-table-title-wrap {
		> .comp-text {
			white-space: unset;
		}
	}

	.order-table-item-wrap {
		.col-item {
			&:last-child {
				white-space: unset;
			}

			.status-item {
				font-weight: 500;
			}

			> .btn-wrap {
				.link-item {
					font-weight: 500;
					color: var(--neutral300);
					transition: color 0.2s ease-out;

					@media (pointer: fine) {
						@media (hover: hover) {
							&:hover {
								color: var(--pink1000);
							}
						}
					}
				}
			}
		}
	}

	/* //! Empty Orders Styles */
	.empty-orders {
		.empty-orders-title {
			font-weight: 500;
		}

		.empty-orders-description {
			font-weight: 400;
		}

		> .btn-wrap {
			.link-item {
				font-weight: 500;
				color: rgba(0, 0, 0, 0.4);
				transition: color 0.2s ease-out;

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							color: var(--pink1000);
						}
					}
				}
			}
		}
	}

	/* //! Order History Individual Styles */
	.order-info-wrap {
		> .btn-wrap {
			.link-item {
				font-weight: 500;
			}
		}

		.order-detail-item-wrap {
			.status-item {
				font-weight: 500;
			}
		}

		.ordered-items-wrapper {
			.col-item-3,
			.col-item-4 {
				.comp-text {
					font-weight: 500;
					font-size: var(--p4);
				}
			}

			.order-sale-price {
				color: var(--neutral1000);
			}

			.discount-text {
				color: var(--pink1000);
				font-size: var(--p6) !important;
			}

			.order-price1 {
				font-weight: 400 !important;
				font-size: var(--p5) !important;
				color: var(--neutral400);
			}

			.col-1-right-wrap {
				.ordered-item-title {
					a,
					button {
						text-align: left;
					}
				}
			}
		}

		.reorder-btn {
			a,
			button {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}
	}

	/* //! Addresses Styles */
	.address-wrap {
		.is-default {
			display: none !important;
		}

		.address-title-container {
			> .comp-text {
				font-weight: 500;
			}

			> .btn-wrap {
				a,
				button {
					font-weight: 500;
					color: var(--neutral1000);
					transition: color 0.2s ease-out;

					@media (pointer: fine) {
						@media (hover: hover) {
							&:hover {
								color: var(--pink1000);
							}
						}
					}
				}
			}
		}

		.flex-wrapper {
			.item-container {
				.item-internal-wrap {
					.is-default {
						font-weight: 400;
					}

					.edit-remove-wrapper {
						.btn-one-address-version,
						.btn-more-address-version {
							a,
							button {
								color: var(--neutral1000);
								font-weight: 500;
								transition: color 0.2s ease-out;

								@media (pointer: fine) {
									@media (hover: hover) {
										&:hover {
											color: var(--pink1000);
										}
									}
								}
							}
						}

						.vertical-line {
							background-color: var(--neutral1000);
						}
					}
				}
			}
		}
	}

	/* //! Delete Popup Styles */
	.warning-message-block {
		.warning-message-title {
			font-weight: 500;
		}

		.warning-message-popup-close {
			a,
			button {
				font-weight: 500;
			}
		}

		.warning-message-popup-remove {
			a,
			button {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}

		.warning-message-popup-confirm {
			a,
			button {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}

		.warning-message-popup-done {
			a,
			button {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}

		.warning-message-popup-continue {
			a,
			button {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}
	}

	/* //! Address Form Styles */
	.address-form-block {
		.address-form-block-title {
			font-weight: 500;
		}

		.default-info-wrap {
			display: none !important;
		}

		form {
			.form-builder {
				row-gap: var(--popupAddressFieldRow) !important;
				margin: calc(var(--popupAddressFieldColumn) * -1) !important;
			}

			.form-wrapper {
				max-height: 60vh !important;
			}

			.form-item {
				padding: 0 var(--popupAddressFieldColumn) !important;

				&.input-line {
					width: calc(100% / 4) !important;
				}
			}
		}

		.form-wrapper {
			label {
				font-weight: 500;
			}

			.form-item {
				&.full-width {
					--account_antFormItemWidth: 100%;
					width: 100%;
				}

				&.disabled {
					font-weight: 400;
				}
			}
		}

		.address-form-is-default-checkbox,
		.address-form-is-default {
			text-decoration-line: underline;
			text-decoration-style: solid;
			text-decoration-skip-ink: none;
			text-decoration-thickness: auto;
			text-underline-offset: auto;
			text-underline-position: from-font;
		}

		.cancel-and-save-wrap {
			.address-form-cancel-btn {
				a,
				button {
					font-weight: 500;
				}
			}

			.address-form-cancel-submit {
				a,
				button {
					font-weight: 500;
					border-radius: var(--projectBtnBorderRadius);
				}
			}
		}
	}

	/* //! Global Error Styles */
	.global-error-wrap {
		.backend-error {
			font-weight: 500 !important;
		}
	}

	/* //! Cart Styles */
	.cart-main-wrap {
		.sticky-wrap {
			will-change: transform;
		}

		.left-panel-wrap {
			.cart-st-wrap {
				.cart-items-title1-version {
					line-height: 1.5;
					font-weight: 500;
				}
			}

			.empty-cart-wrap {
				.empty-cart-title {
					font-weight: 500;
				}
			}

			.empty-cart-btn {
				a,
				button {
					font-weight: 500;
				}
			}
		}

		.sticky-wrap-title {
			font-weight: 500;
		}

		.sticky-wrap-btn {
			a,
			button {
				font-weight: 500;
				border-radius: var(--projectBtnBorderRadius);
			}
		}

		.continue-shop-text,
		.back-to-shop {
			a,
			button {
				font-weight: 500;
			}
		}

		.button-gift {
			button {
				border: unset;
				font-size: var(--p5);
			}
		}

		.order-items-table-wrap,
		.cart-items-table-wrap {
			.titles-wrap {
				.title-wrap {
					> .comp-text {
						font-weight: 500;
					}
				}
			}

			.items-wrap {
				.item-wrap {
					.item-inner-wrapper {
						.col-item-1 {
							.col-1-right-wrap {
								.title-btn {
									a,
									button {
										font-weight: 500;
									}
								}

								.right-second-item-wrap {
									> .comp-text {
										font-weight: 500;
									}
								}
							}
						}

						.tl-col-2 {
							.react-select__control {
								border-radius: var(--projectBtnBorderRadius);
							}
						}

						.col-item-3 {
							.cart-price1,
							.cart-price2,
							.cart-sale-price {
								font-weight: 500;
								font-size: var(--p4);
							}

							.cart-sale-price {
								color: var(--neutral1000);
							}

							.discount-text {
								color: var(--pink1000);
								font-size: var(--p6);
							}

							.cart-price1 {
								font-weight: 400;
								font-size: var(--p5);
								color: var(--neutral400);
							}
						}

						.col-item-4 {
							.cart-total1,
							.cart-total2,
							.cart-sale-total {
								font-weight: 500;
								font-size: var(--p4);
							}

							.cart-total1 {
								color: var(--neutral400);
								font-weight: 400;
								font-size: var(--p5);
							}

							.discount-text {
								color: var(--pink1000);
								font-size: var(--p6);
							}

							.cart-sale-total {
								color: var(--neutral1000);
							}
						}

						.cart-remove-btn {
							a,
							button {
								font-weight: 500;
							}
						}
					}
				}
			}
		}

		.steps-container {
			.step {
				.step-text {
					font-weight: 400;
				}
			}
		}
	}

	/* //! Thank you message styles */
	.confirmation-wrapper {
		.title {
			font-weight: 500;
		}

		.btn-wrap {
			a,
			button {
				font-weight: 500;
			}
		}
	}

	/* //! Checkout */
	.step-review {
		.select-address-wrap {
			.btn-wrap {
				a,
				button {
					color: var(--neutral1000);
					font-weight: 500;
					transition: color 0.2s ease-out;

					@media (pointer: fine) {
						@media (hover: hover) {
							&:hover {
								color: var(--pink1000);
							}
						}
					}
				}
			}
		}

		.flex-wrapper {
			.is-default {
				font-weight: 400;
			}
		}

		.edit-remove-wrapper {
			.btn-one-address-version {
				a,
				button {
					color: var(--neutral1000);
					font-weight: 500;
					transition: color 0.2s ease-out;

					@media (pointer: fine) {
						@media (hover: hover) {
							&:hover {
								color: var(--pink1000);
							}
						}
					}
				}
			}
		}

		.checkout-mt {
			.title-edit-wrapper {
				.cart-items-edit-btn {
					a,
					button {
						color: var(--neutral1000);
						font-weight: 500;
						transition: color 0.2s ease-out;

						@media (pointer: fine) {
							@media (hover: hover) {
								&:hover {
									color: var(--pink1000);
								}
							}
						}
					}
				}
			}
		}
	}

	.badges-wrapper {
		z-index: 1 !important;
	}

	/* //! Product Popup Styles */
	.popup-product-block {
		backdrop-filter: blur(6px);
		-webkit-backdrop-filter: blur(6px);
		transition: var(--trTime) ease-out;

		.popup-content-container {
			--core_popupMaxWidth: 100vw;
			padding: 0 var(--padPopupLR);
			max-height: 100vh;
		}

		.popup-content-wrap {
			padding: 0 !important;
			border-radius: var(--borderRadiusPopup) !important;
			background-color: transparent !important;

			max-height: 100% !important;
		}
	}

	.close-wrap {
		--core_closePosTopSize: var(--sizeClosePopupT);
		--core_closePosRightSize: var(--sizeClosePopupR);
		--core_closeSize: var(--sizeClosePopup);

		--core_black: var(--neutral600) !important;
	}

	/* //! Review Popup Styles */
	.order-rate-popup {
		.popup-content-wrap {
			padding: 0 !important;
		}
	}

	.order-review-popup {
		.popup-content-wrap {
			padding: 0 !important;
		}
	}

	/* //! Cart Select Styles */
	.select-and-out-of-stock-wrap,
	.select-and-out-of-stock-mobile-wrap {
		.react-select__control {
			border-radius: var(--cartSelectControlBorderRadius) !important;
			padding: var(--cartSelectControlPadTB) var(--cartSelectControlPadLR) !important;
			gap: var(--cartSelectControlGap) !important;
			border: 1px solid var(--neutral150) !important;

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						border: 1px solid var(--backgroundColor) !important;
					}
				}
			}

			&--is-focused {
				border: 1px solid var(--backgroundColor) !important;
			}
		}

		.react-select__dropdown-indicator {
			svg {
				width: var(--sp2x) !important;
				height: var(--sp2x) !important;
			}
		}

		.react-select__menu {
			border-radius: var(--cartSelectMenuBorderRadius) !important;
			padding: var(--cartSelectMenuPadTB) var(--cartSelectMenuPadLR) !important;
			box-shadow: unset !important;
			border: 1px solid var(--neutral150) !important;

			.react-select__menu-list {
				margin: var(--sp1x) var(--sp1x) var(--sp1x) 0;

				&::-webkit-scrollbar-thumb {
					background-color: var(--neutral300);
					border-radius: var(--sp1-5x);
				}

				&::-webkit-scrollbar-track {
					background-color: var(--neutral40);
					border-radius: var(--sp1-5x);
				}

				&::-webkit-scrollbar {
					width: var(--sp0-5x);
				}
			}

			.react-select__option {
				padding: var(--cartSelectOptionPadTB) var(--cartSelectOptionPadLR) !important;
				font-size: var(--p5) !important;

				&:first-child {
					padding-top: 0 !important;
				}

				&:last-child {
					padding-bottom: 0 !important;
				}

				&--is-focused {
					background-color: var(--mainColor) !important;
				}
			}
		}

		.react-select-container .react-select__control .react-select__value-container .react-select__placeholder,
		.react-select-container .react-select__control .react-select__value-container .react-select__single-value {
			font-size: var(--p5) !important;
		}
	}

	/* //! Select Scroll Custom Design */
	.form-builder {
		.react-select-container {
			.react-select__menu-list {
				margin: var(--sp1x) var(--sp1x) var(--sp1x) 0;

				&::-webkit-scrollbar-thumb {
					background-color: var(--neutral300);
					border-radius: var(--sp1-5x);
				}

				&::-webkit-scrollbar-track {
					background-color: var(--neutral40);
					border-radius: var(--sp1-5x);
				}

				&::-webkit-scrollbar {
					width: var(--sp1x);
				}
			}
		}
	}

	/* //! Date Picker Styles */
	.flatpickr-calendar.flatpickr-calendar {
		border-radius: var(--sp1x);
		padding-bottom: var(--sp0-5x);

		.flatpickr-months {
			align-items: center;
			gap: var(--sp0-5x);
			padding: var(--sp1x) var(--sp1x) var(--sp0-5x);

			.flatpickr-prev-month,
			.flatpickr-next-month {
				position: static;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				width: var(--sp3x);
				height: var(--sp3x);
				padding: 0;
				border-radius: 50%;
				transition: background-color 0.2s ease-out;

				svg {
					width: var(--sp1-5x);
					height: var(--sp1-5x);
				}

				/* keep the slot when minDate/maxDate disables an arrow, so the month stays centered */
				&.flatpickr-disabled {
					display: flex;
					visibility: hidden;
				}

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							background-color: var(--neutral40);

							svg {
								fill: var(--pink1000) !important;
							}
						}
					}
				}
			}

			.flatpickr-month {
				height: auto;
				overflow: visible;
			}
		}

		.flatpickr-current-month {
			position: relative;
			left: auto;
			width: 100%;
			height: auto;
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: var(--sp0-5x);
			font-size: var(--p4);
			font-weight: 500;

			.flatpickr-monthDropdown-months {
				appearance: none;
				-webkit-appearance: none;
				-moz-appearance: none;
				margin: 0;
				padding: var(--sp0-5x) var(--sp2-5x) var(--sp0-5x) var(--sp1x);
				border-radius: var(--sp0-5x);
				font-weight: inherit;
				/* This inherits font-size from .flatpickr-current-month (var(--p4)),
				   which drops to 14px on mobile. Below 16px, tapping this <select>
				   makes iOS Safari zoom the whole page in on focus. */
				font-size: 16px !important;
				transition: background-color 0.2s ease-out;
				background-color: transparent;
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http:%2F%2Fwww.w3.org%2F2000%2Fsvg' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23000000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
				background-repeat: no-repeat !important;
				background-position: right var(--sp1x) center !important;
				background-size: 10px auto !important;

				@media (pointer: fine) {
					@media (hover: hover) {
						&:hover {
							background-color: var(--neutral40) !important;
						}
					}
				}
			}

			.numInputWrapper {
				display: inline-flex;
				align-items: center;
				width: auto;
				padding-right: var(--sp2x);

				.numInput.cur-year {
					width: 5ch !important;
					text-align: center;
					font-weight: inherit;
					/* Same mobile-zoom issue as .flatpickr-monthDropdown-months above:
					   this is a real, non-readonly editable input (unlike the outer
					   date field), so its inherited 14px font-size on mobile makes iOS
					   Safari zoom the page in the moment it's tapped/focused. */
					font-size: 16px !important;
				}

				span.arrowUp,
				span.arrowDown {
					opacity: 1;
					right: 0;
					width: var(--sp2x);
					padding: 0;
					border: 0;
					background: transparent !important;

					&:after {
						left: 50%;
						margin-left: -4px;
					}
				}

				span.arrowUp:after {
					border-bottom-color: var(--neutral1000);
				}

				span.arrowDown:after {
					border-top-color: var(--neutral1000);
				}

				@media (pointer: fine) {
					@media (hover: hover) {
						span.arrowUp:hover:after {
							border-bottom-color: var(--pink1000);
						}

						span.arrowDown:hover:after {
							border-top-color: var(--pink1000);
						}
					}
				}
			}
		}
	}

	/* //! Grid sizes changed */
	.cart,
	.checkout,
	.thank-you-message {
		.second-version {
			padding-left: var(--contPaddingLR) !important;
			padding-right: var(--contPaddingLR) !important;
		}

		.confirmation-wrapper {
			.description {
				white-space: pre-line;
			}
		}
	}

	.account-container {
		padding-left: var(--contPaddingLR) !important;
		padding-right: var(--contPaddingLR) !important;
	}

	//! Forget password
	.forgot-password {
		.forget-password-style {
			--account_recoveryLinkWrapMTop: var(--forgetLinkWrapMTop);
			--account_tryAgainWrapMTop: var(--forgetAgainWrapMTop);
		}
	}

	//! Expired password
	.expired-page {
		.expired-container {
			--account_expiredTryAgainWrapMTop: var(--forgetAgainWrapMTop);
			--account_expiredRecoveryLinkWrapMTop: var(--forgetLinkWrapMTop);

			.expired-title-text,
			.expired-description-text {
				font-weight: 400;
			}
		}
	}

	/* //! Free shipping & Promo Code for Cart & Checkout */
	.free-shipping-comp-attr,
	.gift-comp-attr {
		font-size: var(--p5) !important;
		line-height: var(--lineHeight) !important;
	}

	.range-value {
		font-weight: 600 !important;
	}

	.promo-code-text,
	.balance-text,
	.comment-text {
		--account_textSize: var(--p4) !important;
		--account_lineHeightSize: var(--lineHeight) !important;
	}

	.promo-code-block,
	.balance-block {
		.base-input {
			font-size: var(--form_p3) !important;
			line-height: var(--form_lineHeight) !important;
		}
	}

	.promo-code-version,
	.balance-version,
	.account-button-wrap--promo,
	.account-button-wrap--balance,
	.btn-wrap.promo,
	.btn-wrap.balance {
		a,
		button,
		.account-button--promo,
		.account-button--balance {
			border: 2px solid transparent !important;
			background-color: var(--neutral1000) !important;
			color: var(--mainColor) !important;
			font-size: var(--form_p3) !important;
			line-height: var(--form_lineHeight) !important;

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						background-color: var(--pink1000) !important;
					}
				}
			}
		}
	}

	.promo-code-success-text,
	.balance-success-text {
		font-size: var(--p4) !important;
		line-height: var(--lineHeight) !important;
	}

	.promo-code-remove-text,
	.balance-remove-text {
		font-size: var(--p5) !important;
		line-height: var(--lineHeight) !important;
	}

	//! Account balance
	.account-balance-murakami {
		.text-title,
		.balance-value {
			font-size: var(--h4) !important;
			line-height: var(--lineHeightS) !important;
		}

		.status-title-section-progress,
		.title-section-history,
		.voucher-title {
			font-size: var(--p1) !important;
			line-height: var(--lineHeight) !important;
		}

		.description-status {
			font-size: var(--p2) !important;
			line-height: var(--lineHeight) !important;
		}

		.status-title,
		.info-text,
		.info-value-text {
			font-size: var(--p3) !important;
			line-height: var(--lineHeight) !important;
		}

		.next-status-value,
		.next-status-text,
		.next-status-title,
		.balance-title,
		.date-info-text,
		.amount-info-text,
		.category-desktop-text,
		.how-earn-text,
		.voucher-description {
			font-size: var(--p4) !important;
			line-height: var(--lineHeight) !important;
		}

		.text-progress-cashback,
		.text-progress-value,
		.activity-info-text {
			font-size: var(--p5) !important;
			line-height: var(--lineHeight) !important;
		}

		.account-progress-status-wrapper {
			--account_font_size_status_progress: var(--p4);
			--account_line_height_status_progress: var(--lineHeight);
		}

		.icon-value {
			--sizeIcon: var(--sp1x);

			i {
				font-size: var(--sizeIcon);
			}
		}

		.pg-container {
			--account_pgNumbersMarginH: var(--paginationHistoryBalanceMargin);
			height: var(--sp3x);

			.pg-icon {
				display: flex;
				align-items: center;
				height: 100%;
			}

			.pg-numbers {
				font-size: var(--p4) !important;
				line-height: 1;
			}
		}

		.voucher-form-container {
			.base-input {
				font-size: var(--p4) !important;
				line-height: var(--lineHeight) !important;
			}

			.btn-wrap {
				a,
				button {
					font-size: var(--p4) !important;
					line-height: var(--lineHeight) !important;
					font-weight: 500 !important;
				}
			}
		}
	}

	/* //! Payment Popup */
	.popup-payment-block {
		.select-payment-wrap h6 {
			font-size: var(--h5);
		}

		.new-card-wrap {
			p {
				font-size: var(--p4);
			}
		}

		.card-full-name,
		.card-wrap-bottom p,
		.card-wrap-bottom button {
			font-size: var(--p4) !important;
		}

		.card-number {
			font-size: var(--h5);
		}

		.card-wrap-center {
			gap: var(--cartPopupWrapCenterGap) !important;
		}
	}

	/* //! Single Payment */
	.payment-item-container {
		.payment-item-left {
			p {
				font-size: var(--p4) !important;
			}
		}
	}

	.single-payment {
		.card-type,
		.card-number {
			font-size: var(--p4) !important;
		}
	}

	/* //! Account Payment */
	.account-payment-block {
		.title {
			font-size: var(--h5);
		}

		.new-card-wrap {
			p {
				font-size: var(--p4);
			}
		}
		.card-full-name,
		.card-wrap-bottom p,
		.card-wrap-bottom button {
			font-size: var(--p4) !important;
		}

		.card-number {
			font-size: var(--h5);
		}

		.card-wrap-center {
			gap: var(--cartPopupWrapCenterGap) !important;
		}
	}

	.gift-name-text {
		font-size: var(--p6) !important;
	}

	/* //! Order Rate Review Popup Styles */
	.order-rating-option-item {
		font-size: var(--p5) !important;
	}

	.order-rating-option-block {
		#additional-message {
			--form_p3: var(--p4);
		}
	}

	.order-popup-rate-title,
	.order-popup-review-title {
		font-size: var(--h5) !important;
	}

	.order-popup-rate-order-number,
	.order-popup-review-order-number {
		font-size: var(--p3) !important;
	}

	.restaurant-text,
	.delivery-text {
		font-size: var(--p1) !important;
	}

	.order-rating-option-title {
		font-size: var(--p2) !important;
	}

	.order-popup-success-title {
		font-size: var(--h5) !important;
	}

	.order-popup-success-desc {
		font-size: var(--p3) !important;
	}

	.order-review-title {
		font-size: var(--h6) !important;
	}

	.order-review-desc {
		font-size: var(--p5) !important;
	}

	.order-review-option-title {
		font-size: var(--p4) !important;
	}

	.review-reply-content {
		h5 {
			font-size: var(--p2) !important;
		}

		h6 {
			font-size: var(--p2) !important;
		}

		p {
			font-size: var(--p4) !important;
		}

		ol {
			li {
				font-size: var(--p4) !important;
			}
		}

		ul {
			li {
				font-size: var(--p4) !important;
			}
		}

		blockquote {
			font-size: var(--p4) !important;
		}
	}

	/* //! Select Option Styles */
	.react-select-container .react-select__menu .react-select__menu-list .react-select__option {
		font-size: var(--p4) !important;
	}

	/* //! Error Message Styles */
	.error-message {
		font-size: var(--p5) !important;
	}

	.popup-content-wrap {
		border-radius: var(--sp2x) !important;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeL}) {
		:root {
			/* --projectBtnBorderRadius: var(--sp4x); */
			--padPopupLR: var(--sp20x);
			--borderRadiusPopup: var(--sp2x);

			--sizeClosePopupT: var(--sp5x);
			--sizeClosePopupR: var(--sp5x);
			--sizeClosePopup: var(--sp2-5x);

			--forgetLinkWrapMTop: var(--sp2x);
			--forgetAgainWrapMTop: var(--sp2x);

			--paginationHistoryBalanceMargin: var(--sp2x);

			--cartPopupWrapCenterGap: var(--sp3x);
		}
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeM}) {
		:root {
			/* --projectBtnBorderRadius: var(--sp3x); */
			--padPopupLR: var(--sp13x);
			--borderRadiusPopup: var(--sp2x);

			--sizeClosePopupT: var(--sp4x);
			--sizeClosePopupR: var(--sp4x);
			--sizeClosePopup: var(--sp2-5x);

			--forgetLinkWrapMTop: var(--sp2x);
			--forgetAgainWrapMTop: var(--sp2x);

			--paginationHistoryBalanceMargin: var(--sp2x);

			--cartPopupWrapCenterGap: var(--sp2x);

			--popupAddressFieldRow: var(--sp2x);
			--popupAddressFieldColumn: var(--sp0-5x);
		}
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeS}) {
		:root {
			/* --projectBtnBorderRadius: var(--sp3x); */
			--padPopupLR: var(--sp10x);
			--borderRadiusPopup: var(--sp2x);

			--sizeClosePopupT: var(--sp4x);
			--sizeClosePopupR: var(--sp4x);
			--sizeClosePopup: var(--sp2-5x);

			--forgetLinkWrapMTop: var(--sp2x);
			--forgetAgainWrapMTop: var(--sp2x);

			--paginationHistoryBalanceMargin: var(--sp2x);

			--cartPopupWrapCenterGap: var(--sp1x);

			--popupAddressFieldRow: var(--sp2x);
			--popupAddressFieldColumn: var(--sp0-5x);
		}

		.account-balance-murakami {
			.pg-numbers {
				font-weight: 500;
			}
		}
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSize}) {
		:root {
			/* --projectBtnBorderRadius: var(--sp3x); */
			--padPopupLR: var(--sp8x);
			--borderRadiusPopup: var(--sp1x);

			--sizeClosePopupT: var(--sp4x);
			--sizeClosePopupR: var(--sp4x);
			--sizeClosePopup: var(--sp2-5x);

			--forgetLinkWrapMTop: var(--sp1-5x);
			--forgetAgainWrapMTop: var(--sp1-5x);

			--paginationHistoryBalanceMargin: var(--sp2x);

			--cartPopupWrapCenterGap: var(--sp1x);

			--popupAddressFieldRow: var(--sp2x);
			--popupAddressFieldColumn: var(--sp0-5x);
		}

		.account-balance-murakami {
			.pg-numbers {
				font-weight: 500;
			}
		}

		.address-form-block {
			form {
				.form-item {
					&.input-line {
						width: calc(100% / 2) !important;
					}
				}
			}
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeS}) {
		:root {
			/* --projectBtnBorderRadius: var(--sp3x); */
			--padPopupLR: var(--sp4x);
			--borderRadiusPopup: var(--sp2x);

			--sizeClosePopupT: var(--sp3x);
			--sizeClosePopupR: var(--sp3x);
			--sizeClosePopup: var(--sp2x);

			--forgetLinkWrapMTop: var(--sp1-5x);
			--forgetAgainWrapMTop: var(--sp1-5x);

			--paginationHistoryBalanceMargin: var(--sp1x);

			--cartPopupWrapCenterGap: var(--sp1x);

			--popupAddressFieldRow: var(--sp2x);
			--popupAddressFieldColumn: var(--sp0-5x);
		}

		.account-container {
			padding-left: 0px !important;
			padding-right: 0px !important;
		}

		.close-wrap {
			background-color: var(--mainColor);
			width: var(--sp4x) !important;
			height: var(--sp4x) !important;
			border-radius: 50%;
			cursor: pointer;
		}

		.popup-product-block {
			.popup-content-container {
				padding-top: var(--sp6x) !important;
				padding-bottom: var(--sp6x) !important;
			}
		}

		.forgot-password {
			align-items: center;
			justify-content: center;

			&.success {
				.forget-password-style {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 100%;
					height: 100%;

					--account_forgotPasswordPadT: 0px;
					--account_forgotPasswordPadB: 0px;
				}
			}
		}
		.expired-page {
			--account_resetPasswordPadT: 0px !important;
			--account_resetPasswordPadB: 0px !important;
			align-items: center;
			justify-content: center;
			height: 100%;
			flex: 1;
		}

		.account-balance-murakami {
			.pg-numbers {
				font-weight: 500;
			}
		}

		/* //! 1024 */
		@media only screen and (min-width: 1024px) {
			.account-container {
				padding-left: var(--contPaddingLR) !important;
				padding-right: var(--contPaddingLR) !important;
			}
		}

		.popup-address-form-block,
		.delivery-template-popup {
			.popup-content-container {
				max-width: calc(100% - var(--contPaddingLR) * 2) !important;
			}

			.popup-content-wrap {
				padding: var(--sp4x) !important;
			}
		}

		.cart-modification-warning-popup {
			.popup-content-container {
				max-width: calc(768px - var(--contPaddingLR) * 2) !important;
			}

			.popup-content-wrap {
				padding: var(--sp7x) var(--sp5x) var(--sp5x) !important;
			}
		}

		.address-form-block {
			.form-builder {
				max-height: 60vh !important;
			}

			form {
				.form-item {
					&.input-line {
						width: calc(100% / 2) !important;
					}
				}
			}
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		:root {
			/* --projectBtnBorderRadius: var(--sp3x); */
			--padPopupLR: 0px;
			--borderRadiusPopup: 0px;

			--sizeClosePopupT: var(--sp3x);
			--sizeClosePopupR: var(--sp3x);
			--sizeClosePopup: var(--sp2x);

			--forgetLinkWrapMTop: var(--sp1-5x);
			--forgetAgainWrapMTop: var(--sp1-5x);

			--paginationHistoryBalanceMargin: var(--sp1x);

			--cartPopupWrapCenterGap: var(--sp1x);

			--popupAddressFieldRow: var(--sp1x);
			--popupAddressFieldColumn: var(--sp0-5x);
		}

		.account-container {
			padding-left: 0px !important;
			padding-right: 0px !important;
		}

		.close-wrap {
			background-color: var(--mainColor);
			width: var(--sp4x) !important;
			height: var(--sp4x) !important;
			border-radius: 50%;
			cursor: pointer;
		}

		.popup-product-block {
			.popup-content-wrap {
				max-height: 100% !important;
				min-height: 100% !important;
				border-bottom-left-radius: 0 !important;
				border-bottom-right-radius: 0 !important;
			}
		}

		.forgot-password {
			align-items: center;
			justify-content: center;

			&.success {
				.forget-password-style {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 100%;
					height: 100%;

					--account_forgotPasswordPadT: 0px;
					--account_forgotPasswordPadB: 0px;
				}
			}
		}

		.expired-page {
			--account_resetPasswordPadT: 0px !important;
			--account_resetPasswordPadB: 0px !important;

			align-items: center;
			justify-content: center;
			flex: 1;

			height: 100%;
		}

		.account-balance-murakami {
			.pg-numbers {
				font-weight: 500;
			}
		}

		.popup-product-block {
			.popup-content-wrap {
				background-color: var(--mainColor) !important;
			}
		}

		/* //! Orders list mobile version */
		.mobile-orders-list-wrap {
			.first-col-wrap {
				.right-wrap {
					.status-item {
						font-weight: 500;
					}
				}
			}

			.last-col-wrap {
				.right-wrap {
					> .btn-wrap {
						.link-item {
							font-weight: 500;
							color: var(--neutral300);
							transition: color 0.2s ease-out;

							@media (pointer: fine) {
								@media (hover: hover) {
									&:hover {
										color: var(--pink1000);
									}
								}
							}
						}
					}
				}
			}
		}

		/* //! Cart item mobile version */
		.mobile-cart-items-table-wrap {
			.mobile-info-wrap {
				.mobile-info-wrap-title {
					a,
					button {
						font-size: var(--p5);
						line-height: var(--lineHeight);
					}
				}

				.mobile-info-item {
					.comp-text {
						font-size: var(--p5);
						line-height: var(--lineHeight);
					}
				}

				.mobile-price-wrap,
				.mobile-total-price-wrap {
					.comp-text {
						font-size: var(--p5);
						line-height: var(--lineHeight);
					}

					.discount-text {
						color: var(--pink1000);
						font-size: var(--p6);
					}
				}
			}

			.mobile-discounted-price,
			.mobile-total-discounted-price {
				color: var(--neutral1000);
			}
		}

		/* //! Order item mobile version */
		.price1,
		.total1 {
			font-weight: 400 !important;
		}

		.sale-price,
		.sale-total {
			color: var(--neutral1000) !important;
		}

		.discount-text-mobile {
			color: var(--pink1000) !important;
			font-size: var(--p5) !important;
		}

		.popup-address-form-block,
		.delivery-template-popup,
		.cart-modification-warning-popup {
			.popup-content-container {
				max-width: calc(100% - var(--contPaddingLR) * 2) !important;
				overflow: visible !important;
			}
			.popup-content-wrap {
				padding: var(--sp7x) var(--contPaddingLR) var(--sp4x) !important;
			}
		}

		.address-form-block {
			form {
				.form-builder {
					max-height: 100vh !important;
				}

				.form-item {
					&.input-line {
						width: calc(100% / 2) !important;
					}
				}
			}
		}
	}

	&.has-mobile-header-layout {
		--visible-header-bottom: var(--header-total-height);

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.collapsibleHeaderMaxMin}) {
			--headerFixedHeight: 75.83px;
			--headerBannerHeight: var(--sp5x);
		}

		main {
			padding-top: var(--header-total-height, calc(var(--headerFixedHeight) + var(--headerBannerHeight))) !important;
		}

		.is-sticky-portal,
		.shop-delivery-panel-host {
			transform: translate3d(0, 0, 0);
			-webkit-transform: translate3d(0, 0, 0);
			transition: none;
			will-change: auto;
		}

		@media (prefers-reduced-motion: reduce) {
			.is-sticky-portal,
			.shop-delivery-panel-host {
				transition: none;
			}
		}
	}

	&.is-header-animating.has-mobile-header-layout {
		.is-sticky-portal,
		.shop-delivery-panel-host {
			transition: transform var(--trTime) ease-out;
		}

		@media (prefers-reduced-motion: reduce) {
			.is-sticky-portal,
			.shop-delivery-panel-host {
				transition: none;
			}
		}
	}

	&.is-header-nav-hidden.has-mobile-header-layout {
		--visible-header-bottom: var(--header-collapsed-bottom, var(--header-banner-slot-height, var(--headerBannerHeight)));

		.is-sticky-portal,
		.shop-delivery-panel-host {
			transform: translate3d(0, calc(-1 * var(--nav-height, var(--headerFixedHeight))), 0);
			-webkit-transform: translate3d(0, calc(-1 * var(--nav-height, var(--headerFixedHeight))), 0);
		}
	}

	&.has-mobile-header-layout.has-shop-fulfillment-bar {
		main {
			padding-top: var(--header-total-height, calc(var(--headerFixedHeight) + var(--headerBannerHeight) + 72px)) !important;
			overflow-x: clip !important;
			overflow-y: visible !important;
		}

		.mobile-categories-wrapper {
			min-width: 100% !important;
		}

		.mobile-categories-pin-host {
			display: block;
			width: 100%;
		}

		.mobile-categories-pin-spacer {
			display: block;
			height: 0;
			margin: 0;
			padding: 0;
			border: 0;
			flex-shrink: 0;
			overflow: hidden;
			pointer-events: none;
		}

		.mobile-categories-pin {
			position: relative;
			z-index: 100;
			width: 100%;
		}

		.mobile-categories-pin.is-pinned {
			position: fixed;
			left: 0;
			right: 0;
			top: var(--header-total-height, calc(var(--headerFixedHeight) + var(--headerBannerHeight)));
			z-index: 100;
			width: 100%;
			transform: translate3d(0, 0, 0);
			-webkit-transform: translate3d(0, 0, 0);
			will-change: transform;
			transition: none;
		}

		.draggable-wrapper {
			background-color: var(--backgroundColor);
		}
	}

	&.is-header-animating.has-mobile-header-layout.has-shop-fulfillment-bar {
		.mobile-categories-pin.is-pinned:not(.is-pin-snap) {
			transition: transform var(--trTime) ease-out;
			will-change: transform;
		}

		.mobile-categories-pin.is-pinned.is-pin-snap {
			transition: none;
		}

		@media (prefers-reduced-motion: reduce) {
			.mobile-categories-pin.is-pinned {
				transition: none;
			}
		}
	}

	&.is-header-nav-hidden.has-mobile-header-layout.has-shop-fulfillment-bar {
		.mobile-categories-pin.is-pinned {
			transform: translate3d(0, calc(-1 * var(--nav-height, var(--headerFixedHeight))), 0);
			-webkit-transform: translate3d(0, calc(-1 * var(--nav-height, var(--headerFixedHeight))), 0);
		}
	}

	body.is-lang-dropdown-open {
		header {
			z-index: 100001 !important;
		}
	}
`}`;

export default RewriteStyle;
